import React from 'react';
import { Form } from 'src/components/Antd';
import { Select } from 'src/components/Antd/Select';
import { generalFilterOptions } from 'src/tools/helper';

const Item = Form.Item;
const Option = Select.Option;

const GeneralMultiSelection = (props) => {
  const { noStyle, name, rules, options, placeholder } = props;

  return (
    <Item
      noStyle={noStyle}
      name={name}
      rules={
        rules ||
        [
          // {
          //   required: true,
          //   message: 'Please select at least one sales channel',
          // },
        ]
      }>
      <Select
        mode='multiple'
        size='large'
        filterOption={generalFilterOptions}
        showSearch
        placeholder={placeholder}
        //open={true}
        // getPopupContainer={() => document.body}
      >
        {(options || []).map((i) => {
          const { label, value } = i;
          return (
            <Option value={value} key={value}>
              {label}
            </Option>
          );
        })}
      </Select>
    </Item>
  );
};
export default GeneralMultiSelection;
